export default "__VITE_ASSET__nBLyP_N5__"